import React, {useContext, useState} from 'react';
import {FormControl, RadioGroup, FormControlLabel, Radio, Typography, FormLabel} from '@mui/material';
import { FLOOD_TEXT } from "../constants/constants";
import {DataContext} from "../contexts/DataContext";

function ThresholdSelector(props) {

    const {data, type} = props;

    const thresholds = Object.keys(data).map(key => parseInt(key.replace('thresh_', ''), 10));

    const {
        updateSelectedThreshold,
        updateSelectedThresholdPop,
        updateSelectedThresholdEco
    } = useContext(DataContext);

    //const [threshold, setThreshold] = useState(selectedThreshold);

    const handleThresholdChange = (event) => {
        //setThreshold(event.target.value);
        //updateSelectedThreshold(event.target.value);
        if (type === 'population') {
            updateSelectedThresholdPop(event.target.value);
        } else if (type === 'economic') {
            updateSelectedThresholdEco(event.target.value);
        }
    };

    return (
        <div style={{ textAlign: 'center' }}>
            <FormControl component="fieldset">
                <FormLabel id="graph-threshold-selector">Flood Depth</FormLabel>
                <RadioGroup
                    row // Add the 'row' prop to make the selection horizontal
                    name="threshold"
                    defaultValue={0}
                    aria-labelledby="graph-threshold-selector"
                    //value={threshold}
                    onChange={handleThresholdChange}
                >
                    {thresholds.map((thresholdValue) => (
                        <FormControlLabel
                            key={thresholdValue}
                            value={thresholdValue}
                            control={<Radio />}
                            label={FLOOD_TEXT[thresholdValue]} // Assuming FLOOD_TEXT is defined somewhere
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </div>
    );
}

export default ThresholdSelector;
